angular.module('estoffice.legacy').controller('mainController', mainController);

function mainController($scope, $compile, $sce, $http) {
  $scope.toggleModal = function (action, id) {
    var url = '/index.php/' + action + '/' + id + '?act=modal';
    $http({
      method: 'GET',
      url: url,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }).success(function (data) {
      $('.modal-dialog').html('');
      $(data).modal(function (e) {
        return e.preventDefault();
      });
      $compile($('.modal-dialog'))($scope);
    });
  };
}
